<template>
  <div class="dashboard-container">
    <!-- Stats Cards -->
    <b-overlay :show="$store.getters['PTC_Dashboard/getIsLoading']" class="stats-overlay">
      <div class="stats-grid">
        <div class="stat-card stat-primary">
          <div class="stat-icon">
            <feather-icon icon="ShoppingBagIcon" size="24" />
          </div>
          <div class="stat-content">
            <span class="stat-label">Pedidos</span>
            <span class="stat-value">{{ $store.state.PTC_Dashboard.RetornaQTDPedidosDashPTC.qtdTotalPedido || 0 }}</span>
          </div>
          <div class="stat-decoration"></div>
        </div>

        <div class="stat-card stat-success">
          <div class="stat-icon">
            <feather-icon icon="FileTextIcon" size="24" />
          </div>
          <div class="stat-content">
            <span class="stat-label">Notas Fiscais</span>
            <span class="stat-value">{{ $store.state.PTC_Dashboard.RetornaQTDNotasDashPTC.qtdTotalNotas || 0 }}</span>
          </div>
          <div class="stat-decoration"></div>
        </div>

        <div class="stat-card stat-warning">
          <div class="stat-icon">
            <feather-icon icon="CreditCardIcon" size="24" />
          </div>
          <div class="stat-content">
            <span class="stat-label">Títulos</span>
            <span class="stat-value">{{ $store.state.PTC_Dashboard.qtdTitulosDashboardPTC.qtdTotalTitulos || 0 }}</span>
          </div>
          <div class="stat-decoration"></div>
        </div>

        <div class="stat-card stat-danger">
          <div class="stat-icon">
            <feather-icon icon="AlertCircleIcon" size="24" />
          </div>
          <div class="stat-content">
            <span class="stat-label">Títulos Vencidos</span>
            <span class="stat-value">{{ $store.state.PTC_Dashboard.qtdTitulosDashboardPTC.qtdTotalTitulosVencidos || 0 }}</span>
          </div>
          <div class="stat-decoration"></div>
        </div>
      </div>
    </b-overlay>

    <!-- Filters Section -->
    <div class="filters-card">
      <div class="filters-header">
        <feather-icon icon="FilterIcon" size="18" />
        <span>Filtros</span>
      </div>
      <div class="filters-body">
        <div class="filter-group">
          <label for="datepicker-start">Data Inicial</label>
          <div class="input-with-icon">
            <feather-icon icon="CalendarIcon" size="16" class="input-icon" />
            <b-form-input
                id="datepicker-start"
                v-model="tempStartDate"
                type="date"
                class="date-input"
            />
          </div>
        </div>
        <div class="filter-group">
          <label for="datepicker-end">Data Final</label>
          <div class="input-with-icon">
            <feather-icon icon="CalendarIcon" size="16" class="input-icon" />
            <b-form-input
                id="datepicker-end"
                v-model="tempEndDate"
                type="date"
                class="date-input"
            />
          </div>
        </div>
        <div class="filter-actions">
          <button class="btn-refresh" @click="refreshDashboard" title="Atualizar">
            <feather-icon icon="RefreshCcwIcon" size="18" />
          </button>
          <button class="btn-filter" @click="filterDashboard">
            <feather-icon icon="SearchIcon" size="16" />
            <span>Filtrar</span>
          </button>
        </div>
      </div>
    </div>
    <b-overlay :show="$store.state.PTC_Dashboard.RetornaQTDPedidosDashPTC && $store.state.PTC_Dashboard.RetornaQTDPedidosDashPTC.qtdPedidos && $store.state.PTC_Dashboard.RetornaQTDPedidosDashPTC.qtdPedidos.length === 0 || $store.state.PTC_Dashboard.setIsLoading" rounded="sm" >
       <Pedido ref="dadosFiltrados"  />
      <template #overlay>
        <div class="text-center">
          <feather-icon icon="AlertTriangleIcon"  size="52"  class="icon-warning" v-if="!$store.state.PTC_Dashboard.setIsLoading" />
          <p id="cancel-label" v-if="!$store.state.PTC_Dashboard.setIsLoading">Neste momento, não há pedidos para exibir. Por favor, aguarde enquanto novos pedidos são processados.</p>
          <div class="d-flex justify-content-center mb-1" v-if="$store.state.PTC_Dashboard.setIsLoading">
            <b-spinner label="Loading..." />
          </div>
        </div>
      </template>
    </b-overlay>
    <b-overlay :show="$store.state.PTC_Dashboard.RetornaQTDNotasDashPTC && $store.state.PTC_Dashboard.RetornaQTDNotasDashPTC.qtdNotas && $store.state.PTC_Dashboard.RetornaQTDNotasDashPTC.qtdNotas.length === 0 || $store.state.PTC_Dashboard.setIsLoading" rounded="sm">
      <b-row>
        <NotaFiscal ref="atualizaParams" />
        <ChartjsHorizontalBarChart ref="dadosFiltradosTop10"/>
      </b-row>
      <template #overlay>
        <div class="text-center">
          <feather-icon icon="AlertTriangleIcon"  size="52"  class="icon-warning"  v-if="!$store.state.PTC_Dashboard.setIsLoading" />
          <p id="cancel-label"  v-if="!$store.state.PTC_Dashboard.setIsLoading">Neste momento, não há Nótas fiscais para exibir. Por favor, aguarde enquanto novos pedidos são processados. </p>
          <div class="d-flex justify-content-center mb-1" v-if="$store.state.PTC_Dashboard.setIsLoading">
            <b-spinner label="Loading..." />
          </div>
        </div>
      </template>
    </b-overlay>
    <b-overlay :show="$store.state.PTC_Dashboard.qtdTitulosDashboardPTC && $store.state.PTC_Dashboard.qtdTitulosDashboardPTC.titulos && $store.state.PTC_Dashboard.qtdTitulosDashboardPTC.titulos.length === 0 || $store.state.PTC_Dashboard.setIsLoading" rounded="sm" >
      <Titulos ref="dadosFiltradosTitulo"/>
      <template #overlay>
        <div class="text-center">
          <feather-icon icon="AlertTriangleIcon"  size="52"  class="icon-warning" v-if="!$store.state.PTC_Dashboard.setIsLoading" />
          <p id="cancel-label" v-if="!$store.state.PTC_Dashboard.setIsLoading">Neste momento, não há Titulos para exibir. Por favor, aguarde enquanto novos pedidos são processados. </p>
          <div class="d-flex justify-content-center mb-1" v-if="$store.state.PTC_Dashboard.setIsLoading">
            <b-spinner label="Loading..." />
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCol, BCard, BButton, BFormInput,
} from 'bootstrap-vue';
import moment from 'moment';
import { mapState } from 'vuex';
import PTC_DashboardService from '@/services/PTC/PTC_Dashboard.service';
import Pedido from '@/views/app/PTC/DashBoard/Pedido/pedido.vue';
import NotaFiscal from '@/views/app/PTC/DashBoard/NotasFiscais/nfc.vue';
import Titulos from '@/views/app/PTC/DashBoard/Titulos/titulos.vue';
import ChartjsHorizontalBarChart from '@/views/app/PTC/DashBoard/analytics/chart/ChartjsHorizontalBarChart.vue';

const ptc_dashboardService = new PTC_DashboardService();

export default {
  components: {
    BCol,
    BCard,
    BButton,
    BFormInput,
    Pedido,
    NotaFiscal,
    Titulos,
    ChartjsHorizontalBarChart,
  },
  data() {
    const today = new Date();
    const oneYearAgo = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
    return {
      tempStartDate: oneYearAgo.toISOString().substr(0, 10),
      tempEndDate: today.toISOString().substr(0, 10),
      startDate: null,
      endDate: null,
    };
  },
  methods: {
    async getDashboard(startDate, endDate) {
      const query = {
        dataInicial: startDate,
        dataFinal: endDate,
      };

      const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));

      if (perfilLogado && perfilLogado.perfil_acesso_nome === 'ClienteFinal') {
        const clienteData = JSON.parse(localStorage.getItem('clienteData'));
        if (clienteData && clienteData.cliente && clienteData.cliente.clienteid) {
          query.clienteId = clienteData.cliente.clienteid;
        }
      }

      await ptc_dashboardService.RetornaCardsTotais(query);

      this.$refs.dadosFiltrados.atualizarDados(query);
      this.$refs.atualizaParams.atualizaParams(query);
      this.$refs.dadosFiltradosTop10.dadosFiltrados10();
      this.$refs.dadosFiltradosTitulo.atualizarGraficoTitulo();
    },

    buildQuery(startDate, endDate) {
      const query = {
        dataInicial: startDate,
        dataFinal: endDate,
      };

      const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));

      if (perfilLogado && perfilLogado.perfil_acesso_nome === 'ClienteFinal') {
        const clienteData = JSON.parse(localStorage.getItem('clienteData'));
        if (clienteData && clienteData.cliente && clienteData.cliente.clienteid) {
          query.clienteId = clienteData.cliente.clienteid;
        }
      }

      return query;
    },

    async refreshDashboard() {
      const today = moment().format('YYYY-MM-DD');
      const oneYearAgo = moment().subtract(1, 'year').format('YYYY-MM-DD');
      this.tempStartDate = oneYearAgo;
      this.tempEndDate = today;

      const query = this.buildQuery(oneYearAgo, today);

      await ptc_dashboardService.RetornaCardsTotais(query);
      this.$refs.dadosFiltrados.atualizarDados(query);
      this.$refs.atualizaParams.atualizaParams(query);
      this.$refs.dadosFiltradosTop10.dadosFiltrados10();
      this.$refs.dadosFiltradosTitulo.atualizarGraficoTitulo();
    },

    async filterDashboard() {
      const { tempStartDate, tempEndDate } = this;
      const formattedStartDate = moment(tempStartDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
      const formattedEndDate = moment(tempEndDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
      this.startDate = formattedStartDate;
      this.endDate = formattedEndDate;

      const query = this.buildQuery(formattedStartDate, formattedEndDate);

      await ptc_dashboardService.RetornaCardsTotais(query);
      this.$refs.dadosFiltrados.atualizarDados(query);
      this.$refs.atualizaParams.atualizaParams(query);
      this.$refs.dadosFiltradosTop10.dadosFiltrados10();
      this.$refs.dadosFiltradosTitulo.atualizarGraficoTitulo();
    },
  },
  mounted() {
    this.refreshDashboard();
  },
};
</script>
<style scoped lang="scss">
$b2b-dark-1: #0f1628;
$b2b-dark-2: #1a1a2e;
$b2b-dark-3: #16213e;
$b2b-purple: #667eea;
$b2b-purple-light: #764ba2;
$b2b-cyan: #00d4ff;
$b2b-success: #28c76f;
$b2b-danger: #ea5455;
$b2b-warning: #ff9f43;

.dashboard-container {
  padding: 0;
}

// Stats Grid
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;
  margin-bottom: 1.5rem;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  background: var(--sf-card-bg, #ffffff);
  border-radius: 14px;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  overflow: hidden;
  box-shadow: var(--sf-card-shadow, 0 4px 20px rgba(0, 0, 0, 0.08));
  border: 1px solid var(--sf-card-border, transparent);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--sf-shadow-lg, 0 8px 30px rgba(0, 0, 0, 0.12));
  }

  .stat-icon {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    flex-shrink: 0;
  }

  .stat-content {
    display: flex;
    flex-direction: column;
    z-index: 1;
  }

  .stat-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--sf-stat-label, var(--sf-text-muted));
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
  }

  .stat-value {
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--sf-stat-text, var(--sf-text-primary));
    line-height: 1;
  }

  .stat-decoration {
    position: absolute;
    right: -20px;
    top: -20px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    opacity: 0.1;
  }

  &.stat-primary {
    border-left: 4px solid $b2b-purple;

    .stat-icon {
      background: linear-gradient(135deg, $b2b-purple 0%, $b2b-purple-light 100%);
    }

    .stat-decoration {
      background: $b2b-purple;
    }
  }

  &.stat-success {
    border-left: 4px solid $b2b-success;

    .stat-icon {
      background: linear-gradient(135deg, $b2b-success 0%, #48d483 100%);
    }

    .stat-decoration {
      background: $b2b-success;
    }
  }

  &.stat-warning {
    border-left: 4px solid $b2b-warning;

    .stat-icon {
      background: linear-gradient(135deg, $b2b-warning 0%, #ffb976 100%);
    }

    .stat-decoration {
      background: $b2b-warning;
    }
  }

  &.stat-danger {
    border-left: 4px solid $b2b-danger;

    .stat-icon {
      background: linear-gradient(135deg, $b2b-danger 0%, #f78ca0 100%);
    }

    .stat-decoration {
      background: $b2b-danger;
    }
  }
}

// Filters Card
.filters-card {
  background: var(--sf-card-bg, #ffffff);
  border-radius: 14px;
  box-shadow: var(--sf-card-shadow, 0 4px 20px rgba(0, 0, 0, 0.08));
  border: 1px solid var(--sf-card-border, transparent);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.filters-header {
  background: linear-gradient(135deg, $b2b-dark-1 0%, $b2b-dark-3 100%);
  padding: 0.85rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;

  &::before {
    content: '';
    width: 3px;
    height: 16px;
    background: linear-gradient(180deg, $b2b-purple 0%, $b2b-cyan 100%);
    border-radius: 2px;
  }
}

.filters-body {
  padding: 1.25rem;
  display: flex;
  align-items: flex-end;
  gap: 1.25rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.filter-group {
  flex: 1;
  min-width: 180px;

  label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--sf-form-label, $b2b-dark-1);
    margin-bottom: 0.4rem;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
}

.input-with-icon {
  position: relative;

  .input-icon {
    position: absolute;
    left: 0.85rem;
    top: 50%;
    transform: translateY(-50%);
    color: var(--sf-text-muted, rgba($b2b-dark-1, 0.4));
    pointer-events: none;
  }

  .date-input {
    padding-left: 2.5rem !important;
  }
}

.filter-actions {
  display: flex;
  gap: 0.75rem;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-end;
  }
}

.btn-refresh {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  border: 2px solid var(--sf-border-color, rgba($b2b-dark-1, 0.1));
  background: var(--sf-card-bg, #ffffff);
  color: var(--sf-text-primary, $b2b-dark-1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    border-color: $b2b-purple;
    color: $b2b-purple;
    background: var(--sf-accent-bg, rgba($b2b-purple, 0.05));
  }
}

.btn-filter {
  padding: 0 1.5rem;
  height: 42px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, $b2b-purple 0%, $b2b-purple-light 100%);
  color: #ffffff;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 15px rgba($b2b-purple, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba($b2b-purple, 0.4);
  }
}

// Overlay Styling
.icon-warning {
  color: $b2b-warning;
}

// Override deep card styles for this page
::v-deep .card {
  border-radius: 14px !important;
  box-shadow: var(--sf-card-shadow, 0 4px 20px rgba(0, 0, 0, 0.08)) !important;
  background: var(--sf-card-bg, #ffffff) !important;
  border: 1px solid var(--sf-card-border, transparent) !important;

  .card-header {
    padding: 0.85rem 1.25rem !important;
    background: transparent !important;
    border-bottom: 1px solid var(--sf-card-border, #e5e8f0) !important;

    .card-title {
      color: var(--sf-text-primary, #2f2b3d) !important;
      font-weight: 600;
    }
  }

  .card-body {
    padding: 1.25rem !important;
    color: var(--sf-text-secondary, #3d4250) !important;
  }
}
</style>
